import React from 'react'

import { useRecoilCallback, useRecoilValue, useSetRecoilState } from 'recoil'

import {
  Button,
  Modal,
  ModalFoot,
  ModalBody,
  InputText,
  ModalHead,
  FormElement
} from 'mailup-web-components'

import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import {
  backUrlState,
  modalBeeSavedRowMetadataState
} from '../recoil/state/beeSavedRows'
import {
  editBeeSavedRowCancelCallback,
  editBeeSavedRowConfirmCallback
} from '../recoil/callbacks/beeSavedRowsCallback'
import { editorState } from '../recoil/state/editor'

export const ModalBeeSavedRow = () => {
  const intl = useIntl()
  const history = useHistory()
  const { show, metadata, mode } = useRecoilValue(modalBeeSavedRowMetadataState)

  const backUrl = useRecoilValue(backUrlState)

  const setState = useSetRecoilState(modalBeeSavedRowMetadataState)
  const setEditorState = useSetRecoilState(editorState)
  const handleConfirm = useRecoilCallback(editBeeSavedRowConfirmCallback, [])

  const handleCancel = useRecoilCallback(editBeeSavedRowCancelCallback, [])

  const handleNameChange = ({ target: { value } }) => {
    setState(({ metadata, ...prev }) => ({
      ...prev,
      metadata: {
        ...metadata,
        name: value
      }
    }))
  }

  const handleEdit = () => {
    handleCancel()
    const id = metadata.id ? metadata.id : 0

    setEditorState(prev => ({
      ...prev,
      actionModSaveRow: true
    }))
    history.push(
      '/messages/email/save-row/' +
        id +
        '?backurl=' +
        encodeURIComponent(backUrl)
    )
  }

  return (
    <Modal show={show} onClose={handleCancel}>
      <ModalHead
        title={
          mode === 'edit-row'
            ? intl.formatMessage({ id: 'Load.SaveRow.ModalEditTitle' })
            : intl.formatMessage({ id: 'Load.SaveRow.SaveModalTitle' })
        }
      />
      <ModalBody>
        <FormElement
          label={intl.formatMessage({ id: 'Load.SaveRow.ModalEditLabel' })}
          hint={
            mode === 'edit-row'
              ? intl.formatMessage({ id: 'Load.SaveRow.ModalEditHinit' })
              : intl.formatMessage({ id: 'Load.SaveRow.SaveModalHinit' })
          }
        >
          <InputText
            placeHolder={
              mode === 'edit-row'
                ? intl.formatMessage({
                    id: 'Load.SaveRow.ModalEditPlaceHolder'
                  })
                : intl.formatMessage({
                    id: 'Load.SaveRow.SaveModalPlaceHolder'
                  })
            }
            value={metadata.name}
            onChange={handleNameChange}
            maxlength='100'
          />
        </FormElement>
      </ModalBody>
      <ModalFoot>
        <Button
          kind='secondary'
          onClick={handleCancel}
          data-mu-test='modal-saved-rows-btn-cancel'
        >
          {intl.formatMessage({
            id: 'Load.MailupCommon.Cancel'
          })}
        </Button>
        {mode === 'edit-row' && (
          <Button
            kind='secondary'
            onClick={handleEdit}
            data-mu-test='modal-saved-rows-btn-cancel'
          >
            {intl.formatMessage({
              id: 'Load.SaveRow.ModalEditCta'
            })}
          </Button>
        )}
        <Button
          kind='primary'
          onClick={handleConfirm}
          disabled={!metadata.name}
          data-mu-test='modal-saved-rows-btn-save'
        >
          {intl.formatMessage({
            id: 'Load.Common.Save'
          })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}
